import { createSelector } from 'reselect';
import { ArsenalArmyView } from './view/ArsenalArmyView';
import { ArsenalUnitView } from './view/ArsenalUnitView';
import { getArsenalArmy } from '@Selectors/arsenal/selector/getArsenalArmy';
import { getArsenalArmyState } from '@Selectors/arsenal/selector/getArsenalArmyState';
import { createSteps } from '@Selectors/arsenal/createSteps';

export const arsenalArmyPresenter = createSelector(
  [getArsenalArmy, getArsenalArmyState],
  (army, state): ArsenalArmyView => {
    return {
      id: army?.id ?? '',
      name: army?.name ?? '',
      logo: null,
      units:
        army?.units?.map(
          (item) =>
            ({
              id: item.id,
              item: item,
              name: item.name,
              comment: item.comment,
              steps: createSteps(item.steps),
            }) satisfies ArsenalUnitView as ArsenalUnitView,
        ) ?? [],
      readings: createSteps(army?.steps ?? []),
    } satisfies ArsenalArmyView as ArsenalArmyView;
  },
);
